<div class="d-flex flex-column h-100">
  <div class="flex-grow-1 d-flex flex-column justify-content-center">
    <h1 class="text-center mt-4">
      Oops... something went wrong
    </h1>

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1032.24 832.63">
      <defs>
        <linearGradient
          x1="86.9"
          y1="457.32"
          x2="402.8"
          y2="457.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="gray" stop-opacity="0.25" />
          <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
          <stop offset="1" stop-color="gray" stop-opacity="0.1" />
        </linearGradient>
        <linearGradient
          x1="3013.29"
          y1="358.28"
          x2="3255.1"
          y2="358.28"
          gradientTransform="matrix(-1, 0, 0, 1, 3342, 0)"
        />
      </defs>
      <title>Something went wrong</title>
      <ellipse
        cx="530.99"
        cy="416.32"
        rx="466.48"
        ry="416.32"
        fill="#158cba"
        opacity="0.1"
      />
      <ellipse
        cx="172"
        cy="629.28"
        rx="172"
        ry="26.66"
        fill="#158cba"
        opacity="0.1"
      />
      <ellipse
        cx="254.67"
        cy="769.13"
        rx="66.9"
        ry="13.82"
        fill="#158cba"
        opacity="0.1"
      />
      <ellipse
        cx="711.8"
        cy="715.96"
        rx="66.9"
        ry="13.82"
        fill="#158cba"
        opacity="0.1"
      />
      <ellipse
        cx="484.79"
        cy="699.75"
        rx="108.79"
        ry="18.43"
        fill="#158cba"
        opacity="0.1"
      />
      <ellipse
        cx="805.34"
        cy="608.52"
        rx="226.91"
        ry="35.54"
        fill="#158cba"
        opacity="0.1"
      />
      <path
        d="M130.91,580.17a63.14,63.14,0,0,0,3.29,63.39c2,3,3.84,5.16,5.31,5.73,7.05,2.77,21.17,9.58,21.17,9.58l34-13.36s5.52-29.2,10.74-54.27v0c3.56-17.1,7-32.27,8.41-34.93,3.52-6.55,0-77.86,0-77.86s-34-2.28-43.35,23.93l-4.09,8Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M176.05,588.05c20.67,23.69,29.39,3.2,29.39,3.2h0v0c3.56-17.1,7-32.27,8.41-34.93,3.52-6.55,0-77.86,0-77.86s-34-2.28-43.35,23.93l-4.09,8C163.79,531.36,161.2,571,176.05,588.05Z"
        transform="translate(-83.88 -33.68)"
        fill="#fff"
        opacity="0.1"
      />
      <path
        d="M180.59,654.08l120-13.86L322,499.34l-16.19-36.59a148.26,148.26,0,0,0-28-42.24c-8.15-8.59-18-16.85-28.36-21a42.56,42.56,0,0,0-4.33-1.48,11.21,11.21,0,0,0-10,1.77c-14.8,10.49-20.09,55.09-21.8,76.56a239.6,239.6,0,0,1-3.57,26.29Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M260.48,497.82l-25,61.5c13.1-9.58,32.51-61.75,32.51-61.75l17.39,59.48-13.86-62.69a196.07,196.07,0,0,0,1.76-41.14c-1.1-15.74-15.87-41-23.89-53.72a42.56,42.56,0,0,0-4.33-1.48,11.21,11.21,0,0,0-10,1.77c6.3,12.65,22.05,44.28,26.85,53.68C268,465.31,260.48,497.82,260.48,497.82Z"
        transform="translate(-83.88 -33.68)"
        fill="#fff"
        opacity="0.1"
      />
      <path
        d="M280.89,658.87H346a19.75,19.75,0,0,0,19.73-20.75c-1.44-27.92-5.09-77.7-13.77-109.3-4.69-17.05-10.14-26-15.14-30.41a14.77,14.77,0,0,0-8.61-4.05,11.3,11.3,0,0,0-7,1.7C309.12,507.65,295,568.64,295,568.64Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M341,604.78c2.68,7.43,3.74,16,0,24.35l-14.51,7.17s-39-16.53-34.26-50.41c0,0,1.28-7,14.71-6.46A38.07,38.07,0,0,1,341,604.78Z"
        transform="translate(-83.88 -33.68)"
        fill="#fff"
        opacity="0.1"
      />
      <path
        d="M325.5,515.72c-.45-11.88,6-16,11.33-17.31a14.77,14.77,0,0,0-8.61-4.05,22.86,22.86,0,0,0-7.51,12l-13.6,66.29S326.26,535.63,325.5,515.72Z"
        transform="translate(-83.88 -33.68)"
        fill="#fff"
        opacity="0.1"
      />
      <path
        d="M263.76,568.14,296,612.24l5.59,36.4-20.72,10.23L251,665.47a28.71,28.71,0,0,1-8.77.57l-81.51-7.17,11.09-25.71,38.3-53.77Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M251.28,553s22,1.51,13.74,39.31-93.25,40.83-93.25,40.83,18.06-32,45.84-54.93c3.12-2.57,6.13-5.25,9-8.11C233,563.71,245.22,552.48,251.28,553Z"
        transform="translate(-83.88 -33.68)"
        fill="#fff"
        opacity="0.1"
      />
      <path
        d="M271.07,581.5s29.81,27.13,27,68.88"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M321.22,496.06s-31.28,41.6-34.79,105.61"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M213.86,478.43S229,547.18,191.2,599"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M489.61,733.05H652.75a9.14,9.14,0,0,0,8-13.47L579.22,568.1a9.13,9.13,0,0,0-16.08,0L481.57,719.58A9.14,9.14,0,0,0,489.61,733.05Zm91.95-27.68H560.8V684.62h20.76Zm0-34.59H560.8V629.27h20.76Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M489.61,733.05H652.75a9.14,9.14,0,0,0,8-13.47L579.22,568.1a9.13,9.13,0,0,0-16.08,0L481.57,719.58A9.14,9.14,0,0,0,489.61,733.05Zm91.95-27.68H560.8V684.62h20.76Zm0-34.59H560.8V629.27h20.76Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M489.61,738.05H652.75a9.14,9.14,0,0,0,8-13.47L579.22,573.1a9.13,9.13,0,0,0-16.08,0L481.57,724.58A9.14,9.14,0,0,0,489.61,738.05Zm91.95-27.68H560.8V689.62h20.76Zm0-34.59H560.8V634.27h20.76Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M400,656.47a11.2,11.2,0,0,0-2.31-1.12c-2.68-1-5.54-1.26-8.22-2.22a11.77,11.77,0,0,1-4.13-2.44c-.2-.2-.39-.4-.57-.61,1-.63,1.91-1.26,2.9-1.85a34.36,34.36,0,0,0-12.06-12c1.61-2.37,5.24-2.18,7.36-4.09a7,7,0,0,0,2-3.93c.79-3.93-.19-8-1.17-11.87-1.9-7.57-3.82-15.19-6.9-22.35a88.07,88.07,0,0,1-3.74-9.06c-2.59-8.62-.78-18-2.74-26.81-.63-2.83-1.65-5.75-.94-8.55,1.09-4.34,5.94-6.91,7-11.25,3.84-15.45,4.53-31.48,6.71-47.25A60.81,60.81,0,0,0,384,482c0-3.19-.57-6.35-.8-9.53-.62-8.93,1.17-17.85,1.94-26.77a28,28,0,0,1,3.63,8.95,36.13,36.13,0,0,1,.21,8.88,41.71,41.71,0,0,1-.63,5.91c-.49,2.32-1.35,4.54-1.92,6.86a21.21,21.21,0,0,0,.95,13.76c1.36,3,4.35,5.78,7.46,4.88,2.15-.62,3.45-2.76,4.41-4.79,3-6.36,4.67-13.73,2.65-20.49-1.33-4.5-4.25-8.57-4.52-13.27a34.3,34.3,0,0,1,.44-5.61c1.25-10.86-1.45-21.77-2.05-32.69-.16-2.89.1-6.48-.55-9.55-.08-.37-.17-.74-.28-1.09a2.34,2.34,0,0,1,.72.33,6.52,6.52,0,0,0-.14-5.59,14.21,14.21,0,0,1-.94-1.76c-.38-1-.31-2.16-.78-3.12a13.31,13.31,0,0,0-1-1.45c-1.29-1.87-1.36-4.29-1.39-6.56q-.23-17.76-1-35.48c-.27-6-.61-12.14-2.71-17.77a26.64,26.64,0,0,0-9.4-12.47,21.9,21.9,0,0,0-2.11-1.32,7.32,7.32,0,0,0,.6-2.7,6.46,6.46,0,0,0,0-.88l-.06-.5v0a21.1,21.1,0,0,0-2-6,16.86,16.86,0,0,1-1.91-6.56,10.19,10.19,0,0,1,.07-1.24v0c.34-2.88,1.84-5.58,2.37-8.46a14.51,14.51,0,0,0,.22-2.71c0-.31,0-.63,0-.95a.08.08,0,0,0,0,0,27.26,27.26,0,0,0-3.21-10.1c-.5-1-1-2-1.56-3-.26-1.87-.55-3.74-.84-5.6-.16-1.08-.33-2.16-.56-3.23q-.17-.8-.39-1.56c1.55-1.46.65-3.6-.34-5.58-1.91-3.76-1.51-8.25-2.32-12.39a37.44,37.44,0,0,0-2.94-8.32,18.54,18.54,0,0,0-3.19-5.24,19.56,19.56,0,0,0-4.13-3,13.15,13.15,0,0,0-4.1-1.85c-.91-.18-1.84-.17-2.74-.38a8.68,8.68,0,0,1-1.68-.61,11.43,11.43,0,0,0-3.59-1.31,8,8,0,0,0-3.46.66,12.73,12.73,0,0,1-3.72,1c-.45,0-.93,0-1.41,0a3.13,3.13,0,0,0-1.91.46,7.22,7.22,0,0,0-.82.84,11.07,11.07,0,0,1-2.41,1.65A23.75,23.75,0,0,0,318.5,255a10.06,10.06,0,0,1-.29,3.29c-.29.84-.86,1.57-1.1,2.43A6.82,6.82,0,0,0,317,263c.08,1.17.2,2.33.33,3.5h0a7.36,7.36,0,0,0-1.46,3.23v0a4.41,4.41,0,0,0-.09.62v.08h0c-.11,2.09.92,4,1.52,6A21.32,21.32,0,0,1,317,288.2c-.73,2.63-1.77,5.35-2,8v0c0,.06,0,.12,0,.18a9.67,9.67,0,0,0,.46,4c.33.91.82,1.76,1.12,2.68,1.06,3.26-.48,6.68-2.52,9.54l0,0c-.32.45-.65.88-1,1.3l.05,0-.05.05,2.08,1.47c-.61.32-1.22.67-1.84,1a18.92,18.92,0,0,0-6.78,2.51,27.56,27.56,0,0,0-5.5,3.66,23.33,23.33,0,0,0-4.34,6,75.41,75.41,0,0,0-3.68,7.76,24.3,24.3,0,0,0-1.88,6.73c-.86,1.83-1.57,3.8-2.36,5.57-.4.91-.79,1.82-1.18,2.73l-34.42-84.28-5.34,2.22.42,1-1.11.47,1.51,3.68c-.22.15-.44.3-.65.46l-.28.22-.56.44-.28.23-.57.48-.21.18-.71.65,0,0c-.76.69-1.49,1.42-2.2,2.15l-1.83,1.89-.35.37-.61.62-.34.35-.87.87-.06.06-.54.52-.34.32c-.14.14-.29.27-.44.4l-.42.39-.68.58-.2.18-.93.74a26.07,26.07,0,0,1-4,2.57c-5.47,2.83-11.26,5.2-16.6,8.23a47.8,47.8,0,0,0-8.22,5.76c-3.53,3.13-6.52,7-10.61,9.27l-.45.24c-7.24,3.72-15.77,1.49-24,1.33-1.23,0-2.44,0-3.64.08-6.68.52-12.79,3.23-18.7,6.53-4.16,2.33-8.22,4.95-12.3,7.32-2.58,1.49-5.17,3.11-7.77,4.77-6.6,4.19-13.28,8.59-20.19,11.76-6.42,2.94-13,4.81-20,4.45H89c-.67,0-1.34-.09-2-.17-.65,5.25,3.55,9.48,6.35,14.1a14.29,14.29,0,0,1,2.37,6.68,12,12,0,0,1-.2,2.68c-.56,3.24-2.06,6.42-1.65,9.68A11.21,11.21,0,0,0,96,387.11c1.78,2.54,4.25,4.8,5.93,7.45,2.54,4,3.2,8.87,4.19,13.58a28.57,28.57,0,0,0,3.29,9.41c2.16,3.48,5.46,6,8.56,8.67.57.49,1.13,1,1.67,1.5.4.36.79.74,1.16,1.13,3.63,3.71,6.33,9.43,4.14,14.07-.07.16-.15.3-.23.45a4,4,0,0,0,.55.33c2.79,1.36,6.29-.82,8.58-3.13,1.13-1.13,2.2-2.33,3.24-3.55,2.79-3.1,5.35-6.46,8-9.68.72-.87,1.44-1.72,2.18-2.56a37,37,0,0,1,9.88-8,36.29,36.29,0,0,1,6.06-2.46c3.1-1,6.3-1.74,9.41-2.72a77.31,77.31,0,0,0,12.39-5.2A190.55,190.55,0,0,0,205,394l1-.65a34.28,34.28,0,0,0,5.95-4.75c.32-.35.63-.71.92-1.08,1.56-2,2.57-4.37,4-6.45a20.75,20.75,0,0,1,5.61-5.41c6.17-4.15,14.36-5.73,21.69-8l.08,0a84.3,84.3,0,0,0,34.17-20.29l5.48,13.42q-.85,2.38-1.61,4.81c-1.22,4-2.22,8.12-4.61,11.5a8.58,8.58,0,0,0-1.74,3.09,10,10,0,0,1-.41,2.48c-.34.68-1.05,1.13-1.34,1.83-.42,1,.13,2.29-.43,3.23a5.08,5.08,0,0,1-.95,1C271.38,390,271,392,271,393.82a17.83,17.83,0,0,1-.45,5.52,13.15,13.15,0,0,1,1.29-.67,6,6,0,0,0-.11,1,11.14,11.14,0,0,0,.35,2.81,22.19,22.19,0,0,0,2.92,5.84,41.5,41.5,0,0,0,3.13,4.5,41,41,0,0,0,6.62,5.92l10.08,7.78-1,4.21c-2.2,8.82-4.42,17.75-4.53,26.85a115.7,115.7,0,0,0,.81,12.89l.87,8.78c.7,7.07,1.4,14.14,2.17,21.21.49,4.47,1,9,2.58,13.22,2.38,6.41-.25,13.65.76,20.43.8,5.31,2.38,10.8.79,15.93-.64,2-1.76,3.92-2.58,5.9-2.05,4.92-2.26,10.39-2.43,15.72a66.81,66.81,0,0,0,.51,14c.86,4.78,2.76,9.47,2.39,14.32-.52,6.89-5.56,12.78-6.17,19.67-.49,5.49,1.9,10.8,4.47,15.67,1.89,3.59-.75,8.23-1.75,12.18-2,7.75,1.32,15.85,5.37,22.72a1.12,1.12,0,0,0,.51.54c.46.17.89-.29,1.19-.68s.39-.48.6-.71c0,.31.06.62.08.92,0,.65.05,1.3.05,2a20.1,20.1,0,0,0,1.36,7.4,13.07,13.07,0,0,0,.56,1.34,6.18,6.18,0,0,0,1,1.61,6.11,6.11,0,0,0,4,1.68c3.32.36,6.66-.33,10-.62,3.52-.3,7.05-.17,10.58-.25a1.53,1.53,0,0,0,.79-.17,1.35,1.35,0,0,0,.45-.72,8,8,0,0,0,.17-3.94,27.94,27.94,0,0,0-.75-3.13c-.47-1.65-.9-3.31-1.31-5-.08-.31-.15-.62-.22-.93l.16.07q3.23-7.26,6.47-14.52c1.09-2.45,2.2-5.1,1.66-7.73-.39-1.88-1.59-3.47-2.44-5.19-2-4.06-2.08-8.8-2.11-13.34l-.12-25.72c5-6.36,8.09-13.93,10-21.83a70.61,70.61,0,0,1,.59,34,31.67,31.67,0,0,0-.95,5.18c-.39,7.13,5.16,13.17,6.64,20.15a4.54,4.54,0,0,1,.11,1.64,6.15,6.15,0,0,1-.82,1.9c-2.66,4.87-2.37,10.75-2,16.29l1.17.19a3.1,3.1,0,0,0,1.24,1.22h0a6.12,6.12,0,0,0,1.55.64,38.18,38.18,0,0,0,5.83.89c2.82.28,5.65.56,8.48.74,1.12.07,2.24.13,3.36.16a33.55,33.55,0,0,1,4.7.33,34,34,0,0,1,5,1.45c7.29,2.44,15.45,3.83,22.51.79a10.14,10.14,0,0,0,4.11-2.91,4.84,4.84,0,0,0-1.21-7.52ZM303.28,371.4c1.06,2.11,2.12,4.21,3,6.4,1.73,4.24,2.78,9,1.68,13.42-.32,1.3-2.41,2.3-2.4,3.64a3,3,0,0,0-.16.31l-6.53-16A57.08,57.08,0,0,1,303.28,371.4Zm-7.17,34a27.67,27.67,0,0,1-3.54-6.11c-.12-.27-.25-.53-.37-.8a2.4,2.4,0,0,0,.95-.71c1-1.26.46-3.1.61-4.72a10.2,10.2,0,0,1,1.59-4l6.13,15q-.93,2.44-1.74,4.93A35,35,0,0,1,296.11,405.4Z"
        transform="translate(-83.88 -33.68)"
        fill="url(#fb7ae7e0-1793-4d3b-a6c6-7b51ed07a232)"
      />
      <path
        d="M317.69,270.4c-.11,2.09.93,4,1.54,6a21.23,21.23,0,0,1-.29,11.74c-1.12,4-3,8.23-1.57,12.14.33.92.83,1.76,1.13,2.68,1.24,3.8-1.06,7.8-3.58,10.91l9.89,6.93a11.37,11.37,0,0,0,5,2.39c1.85.22,4-.77,4.38-2.59.13-.62,0-1.27.12-1.9a5.16,5.16,0,0,1,2.77-3.84,9.06,9.06,0,0,1,4.79-.89c6.07.33,11.23,4.32,16.75,6.88a67.38,67.38,0,0,0,11.27,3.74c2.19.57,4.62,1.09,6.6,0s2.89-3.62,2.74-5.91a19.33,19.33,0,0,0-2.1-6.51,16.56,16.56,0,0,1-1.93-6.55c0-3.36,1.84-6.42,2.46-9.72.87-4.69-.9-9.46-3.06-13.72s-4.78-8.36-5.83-13a19,19,0,0,0-1.09-4.11,9.36,9.36,0,0,0-2-2.68c-3.71-3.67-9-5.41-14.18-5.79s-10.41.47-15.55,1.36a32.51,32.51,0,0,0-5.77,1.37,36.65,36.65,0,0,0-7.59,4.11C320.25,265.06,317.84,267.43,317.69,270.4Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <g opacity="0.1">
        <path
          d="M375.17,303.57c0,.3,0,.6.06.89.31-2.93,1.85-5.68,2.4-8.61a14.22,14.22,0,0,0,.19-3.56c0,.52-.1,1-.19,1.56C377,297.15,375.13,300.21,375.17,303.57Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M319.9,280.4a17.91,17.91,0,0,0-.67-6,34.78,34.78,0,0,1-1.45-4.66c0,.21-.08.41-.09.62-.11,2.09.93,4,1.54,6A16.89,16.89,0,0,1,319.9,280.4Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M379.14,318.13a5.72,5.72,0,0,1-2.68,4.41c-2,1.09-4.41.57-6.6,0a66.52,66.52,0,0,1-11.27-3.75c-5.52-2.55-10.68-6.54-16.75-6.87a9.06,9.06,0,0,0-4.79.89,5.16,5.16,0,0,0-2.77,3.84c-.07.63,0,1.28-.12,1.9-.39,1.82-2.53,2.81-4.38,2.59a11.37,11.37,0,0,1-5-2.39l-8.89-6.24c-.33.45-.66.89-1,1.3l9.89,6.94a11.37,11.37,0,0,0,5,2.39c1.85.22,4-.77,4.38-2.59.13-.62,0-1.27.12-1.9a5.16,5.16,0,0,1,2.77-3.84,9.06,9.06,0,0,1,4.79-.89c6.07.33,11.23,4.32,16.75,6.87a66.52,66.52,0,0,0,11.27,3.75c2.19.57,4.62,1.09,6.6,0s2.89-3.62,2.74-5.91C379.19,318.46,379.16,318.3,379.14,318.13Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M318.5,302.91a7.74,7.74,0,0,1,.27,1.23,7.25,7.25,0,0,0-.27-3.23c-.3-.92-.8-1.76-1.13-2.68a8.36,8.36,0,0,1-.46-2.07,9.4,9.4,0,0,0,.46,4.07C317.7,301.15,318.2,302,318.5,302.91Z"
          transform="translate(-83.88 -33.68)"
        />
      </g>
      <path
        d="M330.24,682.36a1.31,1.31,0,0,1-.46.72,1.53,1.53,0,0,1-.79.17c-3.56.08-7.12,0-10.67.25-3.36.29-6.73,1-10.08.62a5.17,5.17,0,0,1-5-3.29,13.07,13.07,0,0,1-.56-1.34,19.91,19.91,0,0,1-1.37-7.4c0-.67,0-1.32,0-2a15.17,15.17,0,0,0-.29-2.18,3.31,3.31,0,0,1,.1-2.53c1.42-2.59,4.85-3.11,7.49-3.31a61.85,61.85,0,0,1,18.25,1.34c.47,2.3,1,4.58,1.56,6.86q.62,2.51,1.32,5a28,28,0,0,1,.76,3.13A8,8,0,0,1,330.24,682.36Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M330.24,682.36a1.31,1.31,0,0,1-.46.72,1.53,1.53,0,0,1-.79.17c-3.56.08-7.12,0-10.67.25-3.36.29-6.73,1-10.08.62a5.17,5.17,0,0,1-5-3.29,13.07,13.07,0,0,1-.56-1.34h1.28c4.21,0,8.43-.15,12.64-.15,1.27,0,2.55-.06,3.81-.21s2.29-.36,3.44-.5a47.13,47.13,0,0,1,5.18-.21h1.42A8,8,0,0,1,330.24,682.36Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.06"
      />
      <path
        d="M403.89,663.79a10.23,10.23,0,0,1-4.14,2.91c-7.12,3-15.35,1.65-22.7-.79a34.58,34.58,0,0,0-5.05-1.45,34,34,0,0,0-4.73-.33c-1.13,0-2.26-.09-3.39-.16-2.86-.18-5.71-.46-8.55-.74a38.63,38.63,0,0,1-5.88-.89,6.25,6.25,0,0,1-1.57-.64h0a2.41,2.41,0,0,1-1.44-2.15c.08-1.27,1.4-2,2.56-2.55,10.29-4.45,21.47-6.38,32.57-7.93a13.05,13.05,0,0,0,3.27-1c1.25-.5,1.38.32,2,1.24a7.71,7.71,0,0,0,1,1.18,11.9,11.9,0,0,0,4.16,2.44c2.7,1,5.59,1.27,8.29,2.22a11.35,11.35,0,0,1,2.33,1.12,4.82,4.82,0,0,1,1.22,7.52Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M403.89,663.79a10.23,10.23,0,0,1-4.14,2.91c-7.12,3-15.35,1.65-22.7-.79a34.58,34.58,0,0,0-5.05-1.45,34,34,0,0,0-4.73-.33c-1.13,0-2.26-.09-3.39-.16.92-.87,1.86-1.72,2.82-2.54a8.4,8.4,0,0,1,2.37-1.56,6.86,6.86,0,0,1,3.37-.23c5.72.79,10.86,4.8,16.63,4.45a20.46,20.46,0,0,0,7.65-2.47,13.35,13.35,0,0,0,5-3.56,5.77,5.77,0,0,0,.93-1.79,4.82,4.82,0,0,1,1.22,7.52Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.06"
      />
      <path
        d="M401.88,490c-1,2-2.28,4.17-4.44,4.79-3.14.9-6.16-1.92-7.53-4.88a21.08,21.08,0,0,1-1-13.76c.57-2.31,1.44-4.53,1.93-6.85a41.72,41.72,0,0,0,.64-5.91,36.13,36.13,0,0,0-.21-8.88c-1.61-8.59-9-15-11.46-23.44-1.24-4.21-1.18-8.69-1.11-13.08a13.45,13.45,0,0,1,.34-3.3,5.15,5.15,0,0,1,.3-.86c1.65-3.66,6.54-4.16,9.94-6.29,1.88-1.17,6.15-4.94,7.73-1.5a11.31,11.31,0,0,1,.76,2.39c.65,3.06.39,6.65.55,9.54.61,10.92,3.33,21.82,2.07,32.68a34.09,34.09,0,0,0-.44,5.6c.27,4.7,3.21,8.77,4.56,13.27C406.59,476.29,404.92,483.66,401.88,490Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M397.82,408.45a3.37,3.37,0,0,0-2.3,0l-6.77,2a41.92,41.92,0,0,0-6.91,2.51,16.21,16.21,0,0,0-2.75,1.71,5.15,5.15,0,0,1,.3-.86c1.65-3.66,6.54-4.16,9.94-6.29,1.88-1.17,6.15-4.94,7.73-1.5A11.31,11.31,0,0,1,397.82,408.45Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M398.26,407.69a3.06,3.06,0,0,0-2.74-.22l-6.77,2a41.92,41.92,0,0,0-6.91,2.51,15.88,15.88,0,0,0-3.29,2.14c-3.16-5.49-4-12-4.58-18.3-.32-3.67-.56-7.35-.7-11a49.34,49.34,0,0,1,.16-7.88c.38-3,1.25-5.93,1.79-8.91a40.66,40.66,0,0,0,.62-5.28,51.63,51.63,0,0,0-.53-11.59,71.84,71.84,0,0,0-2.78-12c-.64-1.79-1.41-3.52-2.11-5.28l-.24-.62a72.9,72.9,0,0,1-3.09-9.91c-.32-1.38-.34-2.83-1.4-3.77a18.82,18.82,0,0,1,3-.12q.3,0,.6,0a22.43,22.43,0,0,1,11.44,4A26.73,26.73,0,0,1,390.21,336c2.11,5.63,2.46,11.75,2.73,17.76q.81,17.72,1,35.46c0,2.27.1,4.69,1.4,6.56a13.39,13.39,0,0,1,1,1.45c.47,1,.4,2.11.78,3.12a15.77,15.77,0,0,0,.95,1.76A6.45,6.45,0,0,1,398.26,407.69Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M331.7,290.31c-1-.33-2-.68-3-1l2.08.16A4.2,4.2,0,0,1,331.7,290.31Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M372.65,326.4c-.2.68-.4,1.36-.62,2a38.22,38.22,0,0,1-1.85,4.81,22.38,22.38,0,0,1-4.73,6.86,6.28,6.28,0,0,1-2.36,1.56,7.5,7.5,0,0,1-2.32.22q-4,0-8-.12a28.42,28.42,0,0,1-6.18-.61,22.07,22.07,0,0,1-6.3-2.84c-7.47-4.62-13.61-11.66-16.24-20-.33-1.06-.56-2.33.17-3.16a3.87,3.87,0,0,1,2.55-.87l.12,0a16.11,16.11,0,0,0,6.09-2.09,6.26,6.26,0,0,0,2.78-2.84,7.66,7.66,0,0,0-.09-4.42l-2.22-10.08a10.44,10.44,0,0,0-1.77-4.49c.65.23,1.3.44,2,.62,6.18,1.67,12.94.66,19,2.85,2.32.85,4.64,2.38,5.34,4.76,1.17,4-2.74,8.15-1.62,12.15.75,2.72,3.52,4.29,6,5.56l1.67.85,4.63,2.35.64.32.1.05c1.46.74,3,1.66,3.51,3.23A6,6,0,0,1,372.65,326.4Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M384.85,349.88a21.59,21.59,0,0,1-1.84,7.4,30.23,30.23,0,0,0-3.15,13c-.77,13.5-5.9,29.57,1.45,40.91.18.28.36.56.53.85a15.88,15.88,0,0,0-3.29,2.14c-3.16-5.49-4-12-4.58-18.3-.32-3.67-.56-7.35-.7-11a49.34,49.34,0,0,1,.16-7.88c.38-3,1.25-5.93,1.79-8.91a40.66,40.66,0,0,0,.62-5.28,51.63,51.63,0,0,0-.53-11.59,71.84,71.84,0,0,0-2.78-12c-.64-1.79-1.41-3.52-2.11-5.28l-.24-.62a22.38,22.38,0,0,1-4.73,6.86,6.28,6.28,0,0,1-2.36,1.56,7.5,7.5,0,0,1-2.32.22q-4,0-8-.12a28.42,28.42,0,0,1-6.18-.61,22.07,22.07,0,0,1-6.3-2.84c-7.47-4.62-13.61-11.66-16.24-20-.33-1.06-.56-2.33.17-3.16a3.87,3.87,0,0,1,2.55-.87l.12,0,9,11.13a18,18,0,0,1,2.6,3.89,2.32,2.32,0,0,0,.8,1.19,2.05,2.05,0,0,0,1,.18c8.45,0,19.71,0,28.16,0a7.31,7.31,0,0,0-1.24-4.21c-.26.06-.61.08-.07-.08a28.34,28.34,0,0,0-3.1-9.27,6.45,6.45,0,0,0-.31-.58,10.66,10.66,0,0,1-1.48-3.24,5.4,5.4,0,0,1,3.28,0c1.23.53,1.87,1.86,2.41,3.09.46,1,.92,2.07,1.33,3.12,0,.11.1.23.14.34a22.64,22.64,0,0,1,1.66,6.49c.06.82.26,1.86.94,2.13a.89.89,0,0,0,.34.08,3.78,3.78,0,0,1,4.09,1,9,9,0,0,1,2,3.94,21.56,21.56,0,0,0,1.42,4.24c1.29,2.46-.68,3.56,1.65,5.07a8.12,8.12,0,0,1,2.74,2.46A7.68,7.68,0,0,1,384.85,349.88Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M326.77,663.45c.47,2.3,1,4.58,1.56,6.86l-.06.14c-4.57-2-9.25-4.09-14.24-4.53-4.63-.4-9.66.85-12.81,4.21a15.17,15.17,0,0,0-.29-2.18,3.31,3.31,0,0,1,.1-2.53c1.42-2.59,4.85-3.11,7.49-3.31A61.85,61.85,0,0,1,326.77,663.45Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M366.16,328.37c.47,0,.3,0,.07.08S365.62,328.53,366.16,328.37Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M387.89,650.49a86.86,86.86,0,0,0-12.52,9.69,13.11,13.11,0,0,1-3.95,2.89,11.54,11.54,0,0,1-4.76.49,162,162,0,0,1-18.78-1.86h0a2.41,2.41,0,0,1-1.44-2.15c.08-1.27,1.4-2,2.56-2.55,10.29-4.45,21.47-6.38,32.57-7.93a13.05,13.05,0,0,0,3.27-1c1.25-.5,1.38.32,2,1.24A7.71,7.71,0,0,0,387.89,650.49Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M314.52,316.77c1.47,1.31,3.15,2.37,4.64,3.64,4,3.39,6.52,8.13,9,12.75a8.34,8.34,0,0,1-4.59.31,32.92,32.92,0,0,0,.39,13.37,12.4,12.4,0,0,0-4.47,5.55,37.1,37.1,0,0,0-1.46,7q-2.16,15.61-4.34,31.22a4.84,4.84,0,0,1-1,2.81,5.39,5.39,0,0,0-.76.75,4.15,4.15,0,0,0-.35,2.15c-.06.73-.54,1.6-1.27,1.5a1.58,1.58,0,0,1-.89-.58,20.42,20.42,0,0,1-2-2.48c-5.9,11.32-8.74,23.52-11.86,35.9-2.23,8.82-4.46,17.74-4.57,26.84a115.68,115.68,0,0,0,.81,12.88l.88,8.78c.71,7.06,1.42,14.13,2.19,21.19.5,4.48,1,9,2.61,13.22,2.4,6.41-.26,13.64.76,20.42.8,5.31,2.39,10.8.79,15.92-.64,2.05-1.76,3.92-2.6,5.9-2.06,4.92-2.27,10.39-2.45,15.72a66,66,0,0,0,.52,14c.86,4.79,2.79,9.48,2.41,14.32-.53,6.89-5.61,12.78-6.23,19.66-.49,5.49,1.92,10.79,4.51,15.66,1.91,3.59-.75,8.23-1.76,12.18-2,7.74,1.33,15.84,5.41,22.71a1.09,1.09,0,0,0,.52.54c.47.17.89-.29,1.2-.68,3.07-3.94,8.51-5.43,13.5-5s9.66,2.49,14.24,4.53L334.79,655c1.1-2.45,2.22-5.1,1.67-7.73-.39-1.88-1.6-3.47-2.46-5.19-2-4.06-2.1-8.79-2.12-13.34l-.12-25.7c5.06-6.36,8.15-13.92,10.1-21.82a70,70,0,0,1,.6,34,30.85,30.85,0,0,0-1,5.18c-.39,7.13,5.2,13.16,6.69,20.14a4.33,4.33,0,0,1,.12,1.64,6.18,6.18,0,0,1-.83,1.9c-2.68,4.86-2.39,10.75-2,16.29a162.33,162.33,0,0,0,21.21,2.27,11.92,11.92,0,0,0,4.76-.49,13.14,13.14,0,0,0,3.95-2.9A87.22,87.22,0,0,1,390.23,648a34.62,34.62,0,0,0-12.15-12c1.61-2.37,5.28-2.18,7.42-4.08a7,7,0,0,0,2-3.94c.8-3.92-.19-8-1.18-11.85-1.92-7.58-3.85-15.19-7-22.35a85.88,85.88,0,0,1-3.76-9.05c-2.62-8.62-.79-18-2.77-26.81-.64-2.82-1.67-5.73-.95-8.54,1.1-4.33,6-6.9,7.08-11.24,3.87-15.45,4.56-31.46,6.76-47.23a60.68,60.68,0,0,0,.79-9.11c0-3.19-.57-6.35-.8-9.53-.9-12.73,3.17-25.43,2.13-38.15a48,48,0,0,0-7.52-22c-7.35-11.35-2.22-27.41-1.45-40.91a30.08,30.08,0,0,1,3.14-13,21.33,21.33,0,0,0,1.85-7.4,7.65,7.65,0,0,0-.56-4.67,7.89,7.89,0,0,0-2.73-2.46c-2.33-1.52-.36-2.62-1.65-5.08a21.34,21.34,0,0,1-1.42-4.24,8.92,8.92,0,0,0-2-3.93,3.78,3.78,0,0,0-4.09-1c-.95,0-1.21-1.26-1.29-2.21-.27-3.48-1.71-6.75-3.12-9.95-.54-1.23-1.18-2.56-2.41-3.09a5.51,5.51,0,0,0-3.29,0,10.63,10.63,0,0,0,1.49,3.25,28.24,28.24,0,0,1,3.4,9.84c-1,.3,1,0,0,0a7,7,0,0,1,1.31,4.29c-8.44,0-19.7,0-28.15,0a2,2,0,0,1-1-.18,2.4,2.4,0,0,1-.81-1.19,17.33,17.33,0,0,0-2.6-3.88L325,314.1a2.5,2.5,0,0,0-.85-.77,2.3,2.3,0,0,0-1.25,0C319.69,313.8,317.32,315.14,314.52,316.77Z"
        transform="translate(-83.88 -33.68)"
        fill="#158cba"
      />
      <path
        d="M350.05,482.21a9.54,9.54,0,0,1,4.87,1.26,4.91,4.91,0,0,1,2.42,4.22c-.11,1.89-1.56,3.39-2.61,5a13.4,13.4,0,0,0-1.54,3.16,1.27,1.27,0,0,0-.08.81c.12.38.53.57.88.74a7.51,7.51,0,0,1,4.41,6.56c-.09,3.9-3.9,7.06-3.69,11a22.62,22.62,0,0,0,.42,2.44,18.64,18.64,0,0,1-1.35,9.89c-1.21,3.14-2.86,6.09-4.16,9.2-3.51,8.45-4.27,17.81-4,27,.21,6.24-2,12.18-4,18.12a260.46,260.46,0,0,0,.9-36c-.14-3.26-.55-6.34-.4-9.61.24-5.19,3.14-9.91,3.88-15,.42-2.91.14-5.87.21-8.81.14-6,1.77-11.92,1.88-17.94C348.23,490,347.84,485.62,350.05,482.21Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M308.32,318.91a27.42,27.42,0,0,0-5.54,3.66,23.6,23.6,0,0,0-4.38,6,76.64,76.64,0,0,0-3.71,7.76c-1.41,3.44-2.58,7.25-1.61,10.84.88,3.25,3.37,5.78,5.09,8.67s2.73,6.28,4.05,9.45c1.76,4.23,4.17,8.17,5.91,12.41s2.79,9,1.69,13.41c-.32,1.3-2.43,2.31-2.43,3.64,0,2.2,3.18,4.59,5.29,5.23,2.43.75,5.08-.37,7.07-2,3.65-2.89,5.87-7.22,7.51-11.58,2.64-7,4.05-14.43,5.32-21.81.92-5.42,1.78-10.85,2.27-16.31.45-4.92.59-10-.71-14.72a25,25,0,0,0-6.83-11.36c-2.6-2.5-6.86-5.86-10.64-5.95C313.68,316.24,310.88,317.5,308.32,318.91Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M336.75,439.46a4.78,4.78,0,0,1-2.23,3.33,13.13,13.13,0,0,1-3.81,1.56c-2.68.78-5.52,1.5-8.23.81a16.52,16.52,0,0,1-5.78-3.29l-30.28-23.18a40.89,40.89,0,0,1-6.67-5.92,42.63,42.63,0,0,1-3.16-4.49,22,22,0,0,1-2.94-5.84,10.69,10.69,0,0,1-.36-2.81,5.29,5.29,0,0,1,.64-2.57c.73-1.22,2.29-1.47,3.57-1.81a37.46,37.46,0,0,1,13.17-1,1.79,1.79,0,0,1,1.78,1.21c.67,1.23,1.25,2.51,1.85,3.79a27.4,27.4,0,0,0,3.57,6.11,51.54,51.54,0,0,0,4.45,4.29c3.2,3,5.82,6.6,9.23,9.36,3.95,3.19,8.75,5.1,13.25,7.45s8.94,5.4,11.2,9.95A5.83,5.83,0,0,1,336.75,439.46Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M371.8,277.74a24.76,24.76,0,1,1-.69-5.8A24.66,24.66,0,0,1,371.8,277.74Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M371.8,276.74a24.76,24.76,0,1,1-.69-5.8A24.66,24.66,0,0,1,371.8,276.74Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M294.3,399.21c-1.14.73-2.83.49-4.24.17-5.56-1.24-11.7-2.13-16.77.25a5.29,5.29,0,0,1,.64-2.57c.73-1.22,2.29-1.47,3.57-1.81a37.46,37.46,0,0,1,13.17-1,1.79,1.79,0,0,1,1.78,1.21C293.12,396.65,293.7,397.93,294.3,399.21Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M283.85,365.54c-1.23,4-2.24,8.11-4.65,11.5a8.5,8.5,0,0,0-1.76,3.08,9.6,9.6,0,0,1-.41,2.48c-.34.68-1.06,1.13-1.35,1.83-.43,1,.13,2.29-.44,3.23a4.8,4.8,0,0,1-.95,1c-1.36,1.26-1.7,3.27-1.73,5.13s.15,3.76-.46,5.51c5.28-3.15,12-2.21,18-.87,1.67.37,3.74.65,4.82-.69s.46-3.1.61-4.71c.2-2.1,1.64-3.84,2.53-5.75,1-2.15,1.34-4.55,2.11-6.79,1.59-4.71,5-8.55,7.19-13a12.49,12.49,0,0,0,1.42-4.94,14.74,14.74,0,0,0-1.71-6.41,87.68,87.68,0,0,0-7.4-13.21c-1.27-1.87-3.46-5.33-5.43-2.34-1.6,2.41-2.6,5.48-3.78,8.12A148.62,148.62,0,0,0,283.85,365.54Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <path
        d="M374.08,326.72a20.21,20.21,0,0,1-16.18-6.39,2.48,2.48,0,0,1-.72-1.17,2.35,2.35,0,0,1,.46-1.64c1.2-1.85,3.27-3.07,4.23-5.06s.63-4.28.72-6.46c.16-3.91,1.7-7.78,1.83-11.63a12.15,12.15,0,0,0-.22-2.94,18.43,18.43,0,0,1-.84-4.43c.13-2.93,2.77-5.21,3.21-8.1.57-3.68-2.48-6.88-5.55-9a33.07,33.07,0,0,0-7.56-3.91,24.61,24.61,0,0,0-5.08-1.23,19.8,19.8,0,0,0-9.57,1.07,15.63,15.63,0,0,0-3.56,1.9,4.82,4.82,0,0,0-1.59,1.65,5.37,5.37,0,0,0-.42,2.39c-.06,4.09.4,8.44-1.55,12-1,1.91-2.7,3.46-3.53,5.48a9.11,9.11,0,0,0-.63,2.63,26.5,26.5,0,0,0-.15,2.82c-.06,5.27,0,10.83,2.68,15.4a40.15,40.15,0,0,1,2.57,4.31,4.91,4.91,0,0,1-.25,4.79,5.45,5.45,0,0,1-2,1.5,16,16,0,0,1-12.79.46,16.21,16.21,0,0,0,3.78-18.08,10.67,10.67,0,0,1-1.38-4,10.15,10.15,0,0,1,1-3.66,20,20,0,0,0,.61-11.72c-.61-2.38-1.67-4.68-1.86-7.13a21.57,21.57,0,0,1,.24-5.54,18,18,0,0,1,12.33-14.19c.51-.17,1-.33,1.56-.47a33.26,33.26,0,0,1,7.39-.79c5.55-.18,11.18-.34,16.53,1.11a22.18,22.18,0,0,1,8.56,4.4,15.45,15.45,0,0,1,4.14,5.47,19,19,0,0,1,1.17,3.78c.23,1.07.4,2.15.57,3.23,1.21,7.69,2.42,15.53,1.13,23.21-.51,3-1.4,6-1.8,9.06C370.59,312.89,372.34,319.9,374.08,326.72Z"
        transform="translate(-83.88 -33.68)"
        fill="#464353"
      />
      <circle cx="254.67" cy="301.06" r="1.86" fill="#fff" />
      <circle cx="286.06" cy="300.18" r="1.86" fill="#fff" />
      <path
        d="M338.55,240.74l-4-7.55a7.31,7.31,0,0,1,.83-.84,3.17,3.17,0,0,1,1.93-.46Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M349.58,231.54l-4.53,6.7-2.58-7.35a8.18,8.18,0,0,1,3.49-.66A11.6,11.6,0,0,1,349.58,231.54Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <g opacity="0.1">
        <path
          d="M332.38,317.22a5.45,5.45,0,0,1-2,1.5,16.07,16.07,0,0,1-11.37.95,15.57,15.57,0,0,1-1.42,1.51,16,16,0,0,0,12.79-.46,5.45,5.45,0,0,0,2-1.5,4.31,4.31,0,0,0,.64-3.46A3.55,3.55,0,0,1,332.38,317.22Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M321.53,283.73a19.7,19.7,0,0,1,.57,4,19.93,19.93,0,0,0-.57-6c-.61-2.38-1.67-4.68-1.86-7.13,0-.31,0-.62-.05-.94a22.31,22.31,0,0,0,.05,2.94C319.86,279.05,320.92,281.35,321.53,283.73Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M373.29,296.81a43.75,43.75,0,0,0,.54-8,41.68,41.68,0,0,1-.54,6c-.51,3-1.4,6-1.8,9.06a31.56,31.56,0,0,0-.23,4.95,29.52,29.52,0,0,1,.23-2.95C371.89,302.81,372.78,299.84,373.29,296.81Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M321.33,301.1a16.44,16.44,0,0,1-1.26-3.09,4.52,4.52,0,0,0-.12,1.1,10.67,10.67,0,0,0,1.38,4,15.11,15.11,0,0,1,1.25,5.3A15.5,15.5,0,0,0,321.33,301.1Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M364.2,291.39a13.07,13.07,0,0,1,.19,1.38c0-.15,0-.29,0-.44a12.15,12.15,0,0,0-.22-2.94c-.22-1.05-.58-2.09-.75-3.15a4.43,4.43,0,0,0-.09.72A18.43,18.43,0,0,0,364.2,291.39Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M357.9,318.29a5.27,5.27,0,0,1-.43-.51,2.07,2.07,0,0,0-.29,1.34,2.48,2.48,0,0,0,.72,1.17,20.21,20.21,0,0,0,16.18,6.39c-.17-.66-.34-1.31-.5-2A20.18,20.18,0,0,1,357.9,318.29Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M366.55,277a.43.43,0,0,1,0-.11c.57-3.68-2.48-6.88-5.55-9a33.07,33.07,0,0,0-7.56-3.91,24.61,24.61,0,0,0-5.08-1.23,19.8,19.8,0,0,0-9.57,1.07,15.63,15.63,0,0,0-3.56,1.9,4.82,4.82,0,0,0-1.59,1.65,5.37,5.37,0,0,0-.42,2.39c0,.69,0,1.38,0,2.08v-.08a5.37,5.37,0,0,1,.42-2.39,4.82,4.82,0,0,1,1.59-1.65,15.63,15.63,0,0,1,3.56-1.9,19.8,19.8,0,0,1,9.57-1.07,24.61,24.61,0,0,1,5.08,1.23,33.07,33.07,0,0,1,7.56,3.91C363.55,271.61,366.06,274.09,366.55,277Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M331.69,281.79c-1,1.91-2.7,3.46-3.53,5.48a9.11,9.11,0,0,0-.63,2.63,26.5,26.5,0,0,0-.15,2.82c0,.85,0,1.71,0,2.57,0-.19,0-.38,0-.57a26.5,26.5,0,0,1,.15-2.82,9.11,9.11,0,0,1,.63-2.63c.83-2,2.49-3.57,3.53-5.48,1.61-3,1.58-6.45,1.55-9.88A16.68,16.68,0,0,1,331.69,281.79Z"
          transform="translate(-83.88 -33.68)"
        />
      </g>
      <path
        d="M371.59,270.41a2.91,2.91,0,0,1-.48.53,4.58,4.58,0,0,1-1.17.7c-2.91,1.26-2.79-2.85-4.31-4.26a5.17,5.17,0,0,0-3.38-1q-4.39-.22-8.79-.39c-4.89-.18-9.77-.27-14.65-.16q-3.51.06-7,.29c-2.7.18-5.6.53-7.9,1.81a8.37,8.37,0,0,0-2.11,1.65c-.55.6-1.13,1.36-1.89,1.5a18,18,0,0,1,12.33-14.19,24.75,24.75,0,0,1,34,4.25,15.45,15.45,0,0,1,4.14,5.47A19,19,0,0,1,371.59,270.41Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M369.94,269.64c-2.91,1.26-2.79-2.85-4.31-4.26a5.17,5.17,0,0,0-3.38-1,266.53,266.53,0,0,0-30.44-.26c-3.61.24-7.57.78-10,3.46-.62.68-1.27,1.56-2.2,1.53-.31-2-.53-4.08-.68-6.13a6.82,6.82,0,0,1,.12-2.3c.25-.86.82-1.59,1.11-2.43a9.74,9.74,0,0,0,.3-3.28,23.7,23.7,0,0,1,11.66-20.16,10.59,10.59,0,0,0,2.43-1.64,7.31,7.31,0,0,1,.83-.84,3.17,3.17,0,0,1,1.93-.46c.48,0,1,0,1.42,0a12.91,12.91,0,0,0,3.75-1,8.18,8.18,0,0,1,3.49-.66,11.6,11.6,0,0,1,3.62,1.31,8.77,8.77,0,0,0,1.69.61c.91.21,1.85.2,2.76.38a13.47,13.47,0,0,1,4.14,1.84,19.75,19.75,0,0,1,4.16,3,18.41,18.41,0,0,1,3.22,5.24,37.53,37.53,0,0,1,3,8.32c.81,4.14.41,8.62,2.33,12.38C372.06,265.65,373.13,268.27,369.94,269.64Z"
        transform="translate(-83.88 -33.68)"
        fill="#fed253"
      />
      <path
        d="M319.25,266.5s20.73-18.86,51.6-3.22C370.85,263.28,336,255.35,319.25,266.5Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.1"
      />
      <path
        d="M93.37,362.87c-2.82-4.62-7.06-8.85-6.4-14.09,7.76.89,15.12-1,22.23-4.29s13.71-7.56,20.37-11.75c2.62-1.65,5.23-3.27,7.83-4.77,4.12-2.36,8.21-5,12.4-7.31,6-3.3,12.12-6,18.86-6.52a34.4,34.4,0,0,1,3.67-.09c8.3.16,16.9,2.39,24.2-1.33l.45-.24c4.14-2.27,7.15-6.13,10.7-9.26a47.79,47.79,0,0,1,8.29-5.76c5.39-3,11.23-5.4,16.74-8.23a25.39,25.39,0,0,0,4-2.56l.94-.75.21-.18c.23-.19.46-.38.68-.58l.43-.38.44-.4.34-.32.55-.52.06-.07.87-.86.35-.35.61-.63.36-.36c.61-.63,1.22-1.27,1.84-1.89s1.46-1.46,2.21-2.15l0,0,.72-.64.21-.18.58-.48.27-.23.57-.44.28-.22c.28-.21.57-.41.86-.61a6.26,6.26,0,0,1,.84-.49l-1.87-4.53,5.38-2.22,74.2,180.05-5.39,2.22-42.44-103-.3.3a85.2,85.2,0,0,1-35.09,20.88l-.08,0c-7.39,2.23-15.66,3.81-21.88,7.95a21,21,0,0,0-5.65,5.41c-1.46,2.08-2.48,4.45-4,6.45-.29.37-.61.73-.93,1.07a34.77,34.77,0,0,1-6,4.76l-.95.65a194.48,194.48,0,0,1-20.1,12.39,79.3,79.3,0,0,1-12.49,5.2c-3.13,1-6.36,1.73-9.49,2.72a37.16,37.16,0,0,0-6.11,2.46c-5.3,2.77-9.37,7.11-13.22,11.74-3.37,4.06-6.57,8.36-10.27,12.06-2.32,2.3-5.85,4.48-8.65,3.13l-.57-.33c.09-.15.16-.3.24-.46,2.21-4.63-.51-10.35-4.17-14.06-.38-.39-.77-.77-1.17-1.13s-1.12-1-1.69-1.5c-3.13-2.69-6.46-5.19-8.63-8.66a28.25,28.25,0,0,1-3.32-9.41c-1-4.71-1.67-9.56-4.23-13.57-1.68-2.65-4.18-4.91-6-7.45a11.35,11.35,0,0,1-2.2-5.14c-.41-3.25,1.1-6.43,1.67-9.67a12.07,12.07,0,0,0,.21-2.68A14.19,14.19,0,0,0,93.37,362.87Z"
        transform="translate(-83.88 -33.68)"
        fill="url(#26387a05-323e-43c3-b271-53af00551daf)"
      />
      <rect
        x="284.7"
        y="262.55"
        width="5.73"
        height="191.47"
        transform="translate(606.05 546.3) rotate(157.6)"
        fill="#d6d8e1"
      />
      <path
        d="M103.85,393.88c2.51,3.95,3.18,8.71,4.15,13.34a28.1,28.1,0,0,0,3.27,9.26c2.14,3.41,5.41,5.87,8.48,8.51.56.49,1.12,1,1.66,1.48.39.35.78.73,1.15,1.1,3.6,3.65,6.27,9.28,4.1,13.83a3.81,3.81,0,0,1-.23.45,4.57,4.57,0,0,0,.55.32c2.76,1.34,6.23-.8,8.51-3.07,3.64-3.64,6.79-7.86,10.1-11.85,3.78-4.56,7.79-8.83,13-11.55a36,36,0,0,1,6-2.42c3.07-1,6.25-1.71,9.33-2.67a78.53,78.53,0,0,0,12.28-5.11A192.53,192.53,0,0,0,206,393.31l.94-.64a34.35,34.35,0,0,0,5.9-4.67c.32-.34.63-.69.92-1.06,1.54-2,2.55-4.29,4-6.34a20.66,20.66,0,0,1,5.56-5.32c6.12-4.07,14.24-5.63,21.51-7.82l.08,0a83.94,83.94,0,0,0,34.5-20.53,5.62,5.62,0,0,0,1.73-2.54c.31-1.41-.45-2.81-1.18-4.05-.85-1.46-1.68-2.92-2.5-4.4a196.49,196.49,0,0,1-9.86-20.73c-.63-1.56-1.24-3.11-1.83-4.68q-2.27-6-4.14-12.17c-.41-1.36-.81-2.73-1.19-4.1-.07-.26-.15-.54-.22-.84-1.66-6.67-3.88-22.28-10.72-17.61a39.57,39.57,0,0,0-5.65,4.91c-1.33,1.35-2.63,2.74-4,4.08a40.44,40.44,0,0,1-3.53,3.09,25.93,25.93,0,0,1-4,2.52c-5.43,2.78-11.17,5.11-16.46,8.09a46.79,46.79,0,0,0-8.16,5.66c-3.49,3.08-6.45,6.88-10.52,9.11l-.44.24c-7.18,3.65-15.63,1.46-23.8,1.3a35.91,35.91,0,0,0-3.6.09c-6.63.5-12.69,3.16-18.55,6.41-4.12,2.28-8.14,4.86-12.19,7.19-2.56,1.47-5.12,3.06-7.7,4.69-6.54,4.12-13.17,8.44-20,11.56-7,3.18-14.23,5.08-21.86,4.21-.65,5.15,3.51,9.31,6.29,13.85a13.75,13.75,0,0,1,2.35,6.57,11.61,11.61,0,0,1-.19,2.63c-.56,3.19-2,6.31-1.64,9.52A11.05,11.05,0,0,0,98,386.56C99.74,389.05,102.19,391.28,103.85,393.88Z"
        transform="translate(-83.88 -33.68)"
        fill="#f86d70"
      />
      <path
        d="M307.16,414.71s8.76,7.64,17.64,11.71,3,18.67,3,18.67-9.41,2.16-16-7S307.16,414.71,307.16,414.71Z"
        transform="translate(-83.88 -33.68)"
        fill="#fbbebe"
      />
      <path
        d="M779.2,544.76S756,575.29,736.75,575.54s-30.55,12.86-21.41,20.74,108.74-4.5,108.74-4.5.94-37.52-7.69-43S779.2,544.76,779.2,544.76Z"
        transform="translate(-83.88 -33.68)"
        fill="#444176"
      />
      <path
        d="M1028.65,581.41s3.55,24.18-7.42,40.67,19.82,22.85,19.82,22.85,22.37,6.23,24-15.87,1.1-39-1-40.8-3.85-14.23-3.85-14.23Z"
        transform="translate(-83.88 -33.68)"
        fill="#444176"
      />
      <path
        d="M677.45,627.08s-.81-78.21,76.58-110L772,482.89l8.62-21a51.1,51.1,0,0,1,36.09-30.46l13.94-3.13,4.31-18.16a51.08,51.08,0,0,1,40.81-38.54,142.91,142.91,0,0,1,25.7-2.4,22.12,22.12,0,0,1,18.79,11h0s73.32-.81,76.57,39.11c0,0,7.34,36.65,17.93,43.17,0,0,17.92-4.07,35.84,22l19.55,66.8s51.32,48.06,35.84,92c0,0-21.18,30.14-128.71,9.77,0,0-114.86,35-176-13C801.27,640.11,699.45,659.66,677.45,627.08Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M728.77,614.86s16.3-22.81,15.48-39.11,3.84-56,3.84-56"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M788.24,553.76s16.29-30.14,14.66-46.43c0,0,17.11-31,30.14-28.52"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M877.85,468.22s44.8-16.29,47.25-29.32"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M894.14,505.7s47.25-21.18,47.25-26.89H965s34.22,44.81,30.15,64.36"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M949.54,538.28s-45.62-3.26-61.92,9.78S842,567.61,842,567.61s-17.11,36.66-23.63,43.17-17.11,29.33-17.11,29.33"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M949.54,581.46s4.88,17.1,11.4,26.88,16.29,44.8,16.29,44.8"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M1026.11,631.15s10.34,28.77,19.43,29.05"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M958.38,507.66s26.86,7.26,38.09,24.85S1042,566.05,1042,566.05"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M969.9,421s0,37.47,10.59,37.47,34.22,4.07,34.22,4.07"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <path
        d="M918,376.5s-2.71,64.73-16.56,81.49"
        transform="translate(-83.88 -33.68)"
        fill="none"
        stroke="#000"
        stroke-miterlimit="10"
        opacity="0.1"
      />
      <g opacity="0.05">
        <path
          d="M1068.47,550.5l-19.55-66.8c-17.92-26.07-35.84-22-35.84-22-10.59-6.52-17.92-43.18-17.92-43.18-3.26-39.92-76.58-39.1-76.58-39.1h0a22.12,22.12,0,0,0-18.83-11c-3.46,0-7,.11-10.54.4q3,.3,5.75.85l5.7,9.78s73.31-.82,76.57,39.1c0,0,7.34,36.66,17.93,43.18,0,0,17.92-4.08,35.84,22l19.55,66.8s51.32,48.06,35.84,92c0,0-10.45,14.87-53.92,16.67,58.61,2.15,71.84-16.67,71.84-16.67C1119.79,598.56,1068.47,550.5,1068.47,550.5Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M781.72,639.29A380.38,380.38,0,0,1,729.53,645c20.41.78,41.64-1.43,55.32-3.31C783.79,640.88,782.75,640.1,781.72,639.29Z"
          transform="translate(-83.88 -33.68)"
        />
        <path
          d="M957.68,652.33a334.57,334.57,0,0,1-76.92,12.16c37.55,1.36,73.12-6.47,87.78-10.23C965,653.67,961.41,653,957.68,652.33Z"
          transform="translate(-83.88 -33.68)"
        />
      </g>
      <path
        d="M306.73,779.39s22.41-.69,29.16-5.5,34.46-10.55,36.14-2.84,33.67,38.35,8.37,38.56-58.77-3.94-65.51-8.05S306.73,779.39,306.73,779.39Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M380.86,806.92c-25.3.21-58.78-3.94-65.52-8-5.13-3.13-7.18-14.35-7.86-19.52l-.75,0s1.42,18.07,8.16,22.17,40.22,8.25,65.51,8.05c7.31-.06,9.83-2.66,9.69-6.51C389.08,805.43,386.29,806.88,380.86,806.92Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.2"
      />
      <path
        d="M853.07,723.19s-26.39-5.28-33.42-12.32-38.7-19.34-42.22-10.55-47.49,38.7-17.59,44,70.36,7,79.16,3.52S853.07,723.19,853.07,723.19Z"
        transform="translate(-83.88 -33.68)"
        fill="#a8a8a8"
      />
      <path
        d="M759.84,741c29.91,5.27,70.36,7,79.16,3.51,6.69-2.68,11.35-15.55,13.19-21.54l.88.19s-5.28,21.1-14.07,24.62-49.25,1.76-79.16-3.52c-8.63-1.52-11.1-5.1-10.17-9.62C750.41,737.62,753.42,739.89,759.84,741Z"
        transform="translate(-83.88 -33.68)"
        opacity="0.2"
      />
      <path
        d="M600.38,148.53H594.1a4.4,4.4,0,0,0,0-8.8H543.22a4.4,4.4,0,0,0,0,8.8h6.28a4.4,4.4,0,0,0,0,8.79h-8.79a4.4,4.4,0,0,0,0,8.8h50.88a4.4,4.4,0,0,0,0-8.8h8.79a4.4,4.4,0,1,0,0-8.79Z"
        transform="translate(-83.88 -33.68)"
        fill="#158cba"
        opacity="0.1"
      />
      <path
        d="M798,303.34h-6.28a4.4,4.4,0,0,0,0-8.79H740.79a4.4,4.4,0,1,0,0,8.79h6.28a4.4,4.4,0,0,0,0,8.79h-8.79a4.4,4.4,0,1,0,0,8.8h50.87a4.4,4.4,0,0,0,0-8.8H798a4.4,4.4,0,1,0,0-8.79Z"
        transform="translate(-83.88 -33.68)"
        fill="#158cba"
        opacity="0.1"
      />
      <path
        d="M505.17,274.7h-6.28a4.4,4.4,0,1,0,0-8.79H448a4.4,4.4,0,1,0,0,8.79h6.28a4.4,4.4,0,1,0,0,8.79h-8.8a4.4,4.4,0,0,0,0,8.8h50.88a4.4,4.4,0,0,0,0-8.8h8.79a4.4,4.4,0,1,0,0-8.79Z"
        transform="translate(-83.88 -33.68)"
        fill="#158cba"
        opacity="0.1"
      />
    </svg>

    <ng-container *ngIf="afUser$ | async; else noUser">
      <h2 class="lead text-center">
        This is most likely an issue with your current session. Click below to
        sign out and try again.
      </h2>
      <button class="btn btn-outline-dark mx-auto mt-3" (click)="signOut()">
        {{ 'common.signOut' | translate }}
      </button>
    </ng-container>
  </div>
  <app-footer bgColor="" textColor="gray-700"></app-footer>
</div>

<ng-template #noUser>
  <h2 class="mb-4 lead text-center">
    Please try clearing site data and refreshing the page.
  </h2>
  <p class="text-center">
    In Chrome click the 3 dots options menu > More tools > Developer tools >
    Application tab > Storage (upper left sub menu) > Clear site data (button in
    middle of page).
  </p>
  <p class="text-center">Then try going to your account page again.</p>
</ng-template>
